<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row tabs-cont" #tabsCont>
      <div class="col-md-12 h-100">
        <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
          <ngb-tab title="{{'ROBA.BASIC'| translate}}" id="tbList">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-2"><span translate="ROBA.SIFRA.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtSifra" formControlName="Sifra" #focusElement #autofocus [MaxLength]="13"
                        [ngClass]="{'is-invalid': submitted && fc.Sifra.invalid}" [Label]="'ROBA.SIFRA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                        <span *ngFor="let validation of errorMessages.Sifra">
                          <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-2"><span translate="ROBA.BARCODE.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtBarcode" formControlName="Barcode" [MaxLength]="13" [ngClass]="{'is-invalid': submitted && fc.Barcode.invalid}"
                        [Label]="'ROBA.BARCODE.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Barcode.invalid">
                        <span *ngFor="let validation of errorMessages.Barcode">
                          <span class="error-message" *ngIf="fc.Barcode.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-2"><span translate="ROBA.NAZIV.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtNaziv" formControlName="Naziv" [MaxLength]="200" [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                        [Label]="'ROBA.NAZIV.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                        <span *ngFor="let validation of errorMessages.Naziv">
                          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-dropdown-picklist
                        [ModelName]="'robnagrupa'"
                        [GetName]="'GetRoot'"
                        [ModelProperty]="'Naziv'"
                        formControlName="RobnaGrupaID"
                        [Label]="'ROBA.ROBNAGRUPAID.SINGULAR'"
                        [Type]="'treeview'">
                      </yt-dropdown-picklist>
                      <div class="form-error" *ngIf="submitted && fc.RobnaGrupaID.invalid">
                        <span *ngFor="let validation of errorMessages.RobnaGrupaID">
                          <span class="error-message" *ngIf="fc.RobnaGrupaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'tarifa'"
              [GetName]="'getFlat'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]="true"
              formControlName="TarifaID"
              [Label]="'ROBA.TARIFAID.SINGULAR'"
              >
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
              <span *ngFor="let validation of errorMessages.TarifaID">
                <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div> -->

        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
                    [ModelName]="'jedinicamere'"
                    [GetName]="'get'"
                    [ModelProperty]="'Oznaka'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="UnitOfMeasureID"
                    [Label]="'ROBA.UNITOFMEASUREID.SINGULAR'"
                    >
              </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.UnitOfMeasureID.invalid">
                <span *ngFor="let validation of errorMessages.UnitOfMeasureID">
                  <span class="error-message" *ngIf="fc.UnitOfMeasureID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
                    [ModelName]="'akciznaroba'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="AkciznaRobaID"
                    [Label]="'ROBA.AKCIZNAROBAID.SINGULAR'"
                    >
              </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.UnitOfMeasureID.invalid">
                <span *ngFor="let validation of errorMessages.UnitOfMeasureID">
                  <span class="error-message" *ngIf="fc.UnitOfMeasureID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>

        <!-- <div class="form-group row">
          <div class="col-md-12">
             
            <yt-dropdown-picklist
            [ModelName]="'jedinicamere'"
            [GetName]="'get'"
            [ModelProperty]="'Oznaka'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]="true"
            formControlName="AltUnitOfMeasureID"
            [Label]="'ROBA.ALTUNITOFMEASUREID.SINGULAR'"
            >
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.AltUnitOfMeasureID.invalid">
                <span *ngFor="let validation of errorMessages.AltUnitOfMeasureID">
                  <span class="error-message" *ngIf="fc.AltUnitOfMeasureID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>  -->
                  <!-- <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'number'"
              name="txtOdnos"
              formControlName="JmOdnos"
              [ngClass]="{'is-invalid': submitted && fc.JmOdnos.invalid}"
              [Label]="'ROBA.JMODNOS.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.JmOdnos.invalid">
                  <span *ngFor="let validation of errorMessages.JmOdnos">
                    <span class="error-message" *ngIf="fc.JmOdnos.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>          
            </div>
        </div> -->
                </div>
              </div>
            </ng-template>
          </ngb-tab>

          <ngb-tab title="{{'ROBA.BASIC2'| translate}}" id="tbList2">
            <ng-template ngbTabContent>
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input [Type]="'text'" name="txtTezinskiBarcode" formControlName="TezinskiBarcode" [MaxLength]="2000"
                        [ngClass]="{'is-invalid': submitted && fc.TezinskiBarcode.invalid}" [Label]="'ROBA.TEZINSKIBARCODE.SINGULAR'">
                      </yt-input>

                    </div>
                </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="Usluga" id="chkUsluga">
                        <label class="form-check-label" for="chkUsluga">
                          <span translate="ROBA.USLUGA.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="PomocniMaterijal" id="chkPomocniMaterijal">
                        <label class="form-check-label" for="chkPomocniMaterijal">
                          <span translate="ROBA.POMOCNIMATERIJAL.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="Sirovina" id="chkSirovina">
                        <label class="form-check-label" for="chkSirovina">
                          <span translate="ROBA.SIROVINA.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="Ambalaza" id="chkAmbalaza">
                        <label class="form-check-label" for="chkAmbalaza">
                          <span translate="ROBA.AMBALAZA.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="Poluproizvod" id="chkPoluproizvod">
                        <label class="form-check-label" for="chkPoluproizvod">
                          <span translate="ROBA.POLUPROIZVOD.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="TrgovackaRoba" id="chkTrgovackaRoba">
                        <label class="form-check-label" for="chkTrgovackaRoba">
                          <span translate="ROBA.TRGOVACKAROBA.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="GotovProizvod" id="chkGotovProizvod">
                        <label class="form-check-label" for="chkGotovProizvod">
                          <span translate="ROBA.GOTOVPROIZVOD.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="SitanInventar" id="chkSitanInventar">
                        <label class="form-check-label" for="chkSitanInventar">
                          <span translate="ROBA.SITANINVENTAR.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input"
                         type="checkbox"
                         formControlName="OpasnaMaterija" id="chkOpasnaMaterija">
                        <label class="form-check-label">
                          <span translate="ROBA.OPASNAMATERIJA.SINGULAR"
                           style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <yt-input
                    [Type]="'text'"
                    [Label]="'ROBA.AKCIZNAROBASIFRAROBNEMARKE.SINGULAR'"
                    formControlName="AkciznaRobaSifraRobneMarke"
                    [MaxLength]="4"
                  >
                  </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.AkciznaRobaSifraRobneMarke.invalid">
                    <span *ngFor="let validation of errorMessages.AkciznaRobaSifraRobneMarke">
                      <span class="error-message" *ngIf="fc.AkciznaRobaSifraRobneMarke.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
                </div>                
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <!-- <yt-input [Type]="'number'" name="txtRokTrajanjaUDanima" formControlName="RokTrajanjaUDanima"
                        [ngClass]="{'is-invalid': submitted && fc.RokTrajanjaUDanima.invalid}" [Label]="'ROBA.ROKTRAJANJAUDANIMA.SINGULAR'">
                      </yt-input> -->
                      <yt-number-input-v3
                        name="txtRokTrajanjaUDanima"              
                        [Label]="'ROBA.ROKTRAJANJAUDANIMA.SINGULAR'"
                        [FormatString]="'1.0-0'"
                        formControlName=RokTrajanjaUDanima
                        >
                      </yt-number-input-v3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <!-- <yt-input [Type]="'number'" name="txtKolicinaZaPakovanje" formControlName="KolicinaZaPakovanje"
                        [ngClass]="{'is-invalid': submitted && fc.KolicinaZaPakovanje.invalid}" [Label]="'ROBA.KOLICINAZAPAKOVANJE.SINGULAR'">
                      </yt-input> -->
                      <yt-number-input-v3
                        name="txtKolicinaZaPakovanje"              
                        [Label]="'ROBA.KOLICINAZAPAKOVANJE.SINGULAR'"
                        [FormatString]="'1.0-0'"
                        formControlName=KolicinaZaPakovanje
                        >
                      </yt-number-input-v3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <!-- <yt-input [Type]="'number'" name="txtRedosledUListi" formControlName="RedosledUListi" [ngClass]="{'is-invalid': submitted && fc.RedosledUListi.invalid}"
                        [Label]="'ROBA.REDOSLEDULISTI.SINGULAR'">
                      </yt-input> -->
                      <yt-number-input-v3
                        name="txtRedosledUListi"              
                        [Label]="'ROBA.REDOSLEDULISTI.SINGULAR'"
                        [FormatString]="'1.0-0'"
                        formControlName=RedosledUListi
                        >
                      </yt-number-input-v3>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</form>